// =====================================================================
// patientRegistrationService (S86) — fila de cadastro de paciente + aprovação.
//
// Endpoints (recepção autenticada; multi-tenant por companyId do JWT):
//   GET  /patient-registrations?status=&page=&pageSize=  -> { registrations, count, ... }
//   POST /patient-registrations/link        { phone }     -> { url, token, expiresInHours }
//   POST /patient-registrations/:id/approve  { overrides } -> { success, patientId, created }
//   POST /patient-registrations/:id/reject   { reason }    -> { success }
//
// (A submissão do paciente é pública e vem do formulário, não daqui.)
// =====================================================================
import api from "./api";

export const listPendingRegistrations = async ({
  status = "pending",
  page = 1,
  pageSize = 50
} = {}) => {
  const params = { status, page, pageSize };
  const { data } = await api.get("/patient-registrations", { params });
  return data; // { registrations, count, page, pageSize }
};

export const approveRegistration = async (id, overrides) => {
  const body = overrides ? { overrides } : {};
  const { data } = await api.post(`/patient-registrations/${id}/approve`, body);
  return data; // { success, patientId, created }
};

export const rejectRegistration = async (id, reason) => {
  const { data } = await api.post(`/patient-registrations/${id}/reject`, { reason: reason || null });
  return data; // { success }
};

export const generateRegistrationLink = async (phone) => {
  const { data } = await api.post("/patient-registrations/link", { phone: phone || null });
  return data; // { url, token, expiresInHours }
};

// Traduz o erro do backend (AppError -> { error: "ERR_..." }) numa mensagem amigável.
export const registrationErrorMessage = (err) => {
  const code = err && err.response && err.response.data && err.response.data.error;
  const map = {
    ERR_REG_NOT_FOUND: "Cadastro não encontrado.",
    ERR_REG_ALREADY_APPROVED: "Este cadastro já foi aprovado.",
    ERR_PATIENT_CPF_DUPLICATE:
      "Já existe um paciente com esse CPF — confira a ficha existente no Prontuário."
  };
  if (code && map[code]) return map[code];
  if (code && typeof code === "string" && !code.startsWith("ERR_")) return code;
  return "Não foi possível concluir a operação. Tente novamente.";
};
